import { formatDropdownDate } from './constants';

export const getCustomDateRange = (sinceDate, untilDate) => {
    if (sinceDate.getTime() === untilDate.getTime()) {
        return formatDropdownDate(sinceDate);
    }

    return `${formatDropdownDate(sinceDate)} - ${formatDropdownDate(untilDate)}`;
};
